import React from 'react';
import cx from 'classnames';
import Head from 'next/head';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import { fetchLegalDisclosure, getLegalDisclosures } from '@/api/contentStack';
import styles from './legal.module.scss';

export default function LegalContent({ disclosure }) {
  return (
    <>
      <Head>
        <title>{disclosure.title}</title>
        <meta key="og:title" property="og:title" content={disclosure.title} />
      </Head>
      <Col sm="10" md="8" lg="12" className="w-100 d-flex justify-content-center">
        <div className={cx(styles.legalWrapper, "legal p-3")} dangerouslySetInnerHTML={{ __html: disclosure.content }} />
      </Col>
    </>
  );
}

LegalContent.propTypes = {
  disclosure: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
};

export async function getStaticProps({ params, locale }) {
  const res = await fetchLegalDisclosure(`/${params.slug}`, locale);

  return {
    props: {
      disclosure: res,
    },
  };
}

export async function getStaticPaths({ locales }) {
  let paths = [];

  for (const locale of locales) {
    const res = await getLegalDisclosures(locale);

    paths = paths.concat(res.map((entry) => {
      return ({
        params: {
          slug: entry.url.slice(1),
        },
        locale: locale,
      });
    }));
  }

  return { paths, fallback: false };
}
